import type { TableSelectedCell } from '@/components/custom/erp/input-table-v2';
import { useTableRows } from '@/components/custom/erp/input-table-v2';
import type { PurchaseInvoiceTaxRow } from '../../../types';

export type ThueRow = PurchaseInvoiceTaxRow;

export type SelectedThueCellInfo = TableSelectedCell;

export function useThueRows(initialRows: ThueRow[] = []) {
  const {
    rows,
    setRows,
    selectedRowUuid,
    setSelectedRowUuid,
    selectedRow,
    setSelectedRow,
    selectedCell,
    setSelectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    setNonWritableFields,
    setPasteConfigs,
    isPasting
  } = useTableRows<ThueRow>({
    initialRows,
    defaultRows: 0,
    defaultField: 'ma_thue'
  });

  return {
    rows,
    setRows,
    selectedRowUuid,
    setSelectedRowUuid,
    selectedRow,
    setSelectedRow,
    selectedCell,
    setSelectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    setNonWritableFields,
    setPasteConfigs,
    isPasting
  };
}
